import { AddPlayertToGameByEmailRequest, ICreateGroupPlayers } from "@grassrootly/api/entities";
import { provider } from "@grassrootly/api/providers";

export const AddPlayerToGameByEmail = async (params: AddPlayertToGameByEmailRequest): Promise<boolean> =>
  provider.Request("/games/{gameId}/add-player-to-game-by-email", params);
